import { render, staticRenderFns } from "./EventCommentsModal.vue?vue&type=template&id=59db9e4f&scoped=true"
import script from "./EventCommentsModal.vue?vue&type=script&lang=js"
export * from "./EventCommentsModal.vue?vue&type=script&lang=js"
import style0 from "./EventCommentsModal.vue?vue&type=style&index=0&id=59db9e4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db9e4f",
  null
  
)

export default component.exports